module.exports = __webpack_public_path__ + "static/media/partitura-farol.8954db87.png";